import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import {
    BrowserCacheLocation,
    Configuration,
    InteractionType,
    LogLevel
} from '@azure/msal-browser';
import { environment } from '../environments/environment';

/** windows IE detection */
const isIE = window.navigator.userAgent.indexOf( 'MSIE ' ) > -1 || window.navigator.userAgent.indexOf( 'Trident/' ) > -1;

/** list of api endpoints which require auth bearer token */
export const protectedResources = new Map( [
    [ environment.api.identityApi, [ environment.azure.apiScopeUri ] ],
    [ environment.api.registrarApi, [ environment.azure.apiScopeUri ] ],
    [ environment.api.scopeApi, [ environment.azure.apiScopeUri ] ]
] );

/**
 * list of api endpoints which may require auth bearer token
 * this is used in token interceptor {@link TokenInterceptor}, where the called url
 * matches one of those from the list, depending on logged in state the baerer token
 * is added to the request headers or not.
 */
export const securedResources = [
    environment.api.identityApi,
    environment.api.registrarApi,
    environment.api.scopeApi,
    environment.api.impostApi,
    environment.api.communityApi,
    environment.api.registrarNgApi,
    '/scope/rest' // scope client rest api
];

/** implementation of MSAL logger */
export const loggerCallback = ( logLevel: LogLevel, message: string ) => {
    console.log( logLevel, message );
};

/** MSAL Client configuration */
export const msalConfig: Configuration = {
    auth: {
        authority: environment.azure.authoritySigninUrl,
        clientId: environment.azure.clientId,
        knownAuthorities: [ environment.azure.authorityDomain ],
        redirectUri: environment.azure.appRedirectUri,
        postLogoutRedirectUri: '/'
    },
    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage
    },
    system: {
        allowPlatformBroker: false,
        loggerOptions: {
            loggerCallback,
            logLevel: LogLevel.Error,
            piiLoggingEnabled: false
        }
    }
};

/** MSAL Guard configuration */
export const msalGuardConfig = {
    interactionType: InteractionType.Redirect,
    authRequest: {
        scopes: [ 'user.read' ]
    },
    loginFailedRoute: '/'
} as MsalGuardConfiguration;

/** MSAL Interceptor configuration */
export const msalInterceptorConfig = {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: protectedResources
} as MsalInterceptorConfiguration;

/** token request configuration */
export const loginRequest = {
    scopes: [ msalConfig.auth.clientId ]
};
/** refresh token request configuration */
export const tokenRequest = {
    scopes: [ environment.azure.apiScopeUri ]
};

/** export post logout redirect configuration */
export const postLogoutRedirectUri = environment.azure.appRedirectUri;
